
export const getPdf = async (idsoponsor, filename) => {


    const api = await fetch(`https://beneficiosback.grupomok.com/api/PDF_64/${idsoponsor}/${filename}`)
    const result = await api.json()
    const response = result.resultado
    // const data = await api.blob()
    // const dataPdf = URL.createObjectURL(data)

    
    
    const pdfContentType = 'application/pdf';

   
    // console.log(response)
    // Cut the prefix `data:application/pdf;base64` from the raw base 64
    const base64WithoutPrefix = response.substr('data:application/pdf;base64,'.length);

    const bytes = atob(base64WithoutPrefix)
    let length = bytes.length
    let out = new Uint8Array(length)
 

    while (length--) {
        out[length] = bytes.charCodeAt(length)
    }

    const blob = new Blob([out], { type: 'application/pdf' })
    return { pdfUrl : URL.createObjectURL(blob), pdf64: result.resultado}
}

// export const Urlpdf = async () => {
//     const response = await fetch(`https://beneficiosback.grupomok.com/api/PDF_64/1/prueba`)
//     const data = await response.blob()

//     const pdf = URL.createObjectURL(data)

//     return pdf

// }

